import { render, staticRenderFns } from "./SideCart.vue?vue&type=template&id=72736871&scoped=true"
import script from "./SideCart.vue?vue&type=script&lang=js"
export * from "./SideCart.vue?vue&type=script&lang=js"
import style0 from "./SideCart.vue?vue&type=style&index=0&id=72736871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72736871",
  null
  
)

export default component.exports